const LOGIN_NONCE_PREFIX = 'mls:login-nonce';

const getStorage = () => {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage || null;
  } catch {
    return null;
  }
};

const normalizeValue = (value) => {
  if (value == null) return null;
  const stringValue = String(value).trim();
  return stringValue ? stringValue : null;
};

const buildKey = (userId) => {
  const normalizedUserId = normalizeValue(userId);
  if (!normalizedUserId) return null;
  return `${LOGIN_NONCE_PREFIX}:${normalizedUserId}`;
};

export const getMlsLoginNonce = (userId) => {
  const storage = getStorage();
  const key = buildKey(userId);
  if (!storage || !key) return null;
  try {
    return normalizeValue(storage.getItem(key));
  } catch {
    return null;
  }
};

export const setMlsLoginNonce = (userId, nonce) => {
  const storage = getStorage();
  const key = buildKey(userId);
  if (!storage || !key) return null;

  const normalizedNonce = normalizeValue(nonce);

  try {
    if (normalizedNonce) {
      storage.setItem(key, normalizedNonce);
      return normalizedNonce;
    }
    storage.removeItem(key);
  } catch {}
  return null;
};

export const clearMlsLoginNonce = (userId) => {
  const storage = getStorage();
  const key = buildKey(userId);
  if (!storage || !key) return;
  try {
    storage.removeItem(key);
  } catch {}
};

const createNonce = () =>
  typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

/**
 * ✅ Safe: only creates a nonce if one doesn't already exist.
 * force=true should be used ONLY on real logout/login again.
 */
export const markMlsLogin = (userId, { force = false } = {}) => {
  const normalizedUserId = normalizeValue(userId);
  if (!normalizedUserId) return null;

  if (!force) {
    const existing = getMlsLoginNonce(normalizedUserId);
    if (existing) return existing;
  }

  const nonce = createNonce();
  return setMlsLoginNonce(normalizedUserId, nonce);
};
